import { useDebounce } from '@helpers/hooks/use-debounce/useDebounce';
import { useQuery } from '@tanstack/react-query';
import { searchGeographies } from '@terminal/services/geographies/geographies-service';
import { ChangeEvent, useState } from 'react';

export const QUERY_KEY_SEARCH_GEOGRAPHIES = 'QUERY_KEY_SEARCH_GEOGRAPHIES';

const DEBOUNCE_MS = 300;

export const useSearchGeographies = () => {
  const [value, setValue] = useState('');
  const debouncedSearchTerm = useDebounce(value, DEBOUNCE_MS);
  const trimmedSearchTerm = debouncedSearchTerm.trim();

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEY_SEARCH_GEOGRAPHIES, trimmedSearchTerm],
    queryFn: ({ signal }) =>
      searchGeographies(trimmedSearchTerm, undefined, signal),
    enabled: !!trimmedSearchTerm,
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const onClear = () => {
    setValue('');
  };

  return {
    value,
    isSearching: isLoading,
    debouncedSearchTerm: trimmedSearchTerm,
    data: data?.results ?? [],
    handleChange,
    onClear,
  };
};
